module.exports = __webpack_public_path__ + "6441e63a57ccc5105bad045142bc31eb.png";